"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var USNISiteFooter = /** @class */ (function (_super) {
    __extends(USNISiteFooter, _super);
    function USNISiteFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    USNISiteFooter.prototype.render = function () {
        var classes = this.props.classes;
        return (React.createElement("div", { className: classes.footer },
            React.createElement(Grid_1.default, { container: true, spacing: 3, className: classes.footerContent },
                React.createElement(Grid_1.default, { item: true, xs: 4, className: classes.footerColumn },
                    React.createElement(Typography_1.default, { variant: "h5", className: classes.footerHeader }, "General Information"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "U.S. Naval Institute"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "Beach Hall"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "291 Wood Road"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "Annapolis, MD 21402"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "410-268-6110"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "For customer inquiries, please email"),
                    React.createElement(Typography_1.default, { variant: "body2" },
                        React.createElement("a", { href: "mailto:customer@usni.org" }, "customer@usni.org"))),
                React.createElement(Grid_1.default, { item: true, xs: 4, className: classes.footerColumn },
                    React.createElement(Typography_1.default, { variant: "h5", className: classes.footerHeader }, "Member Services and Circulation"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "U.S. Naval Institute"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "291 Wood Road"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "Annapolis, MD 21402"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "800-233-8764"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "or 410-268-6110"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "For member inquiries, please email"),
                    React.createElement(Typography_1.default, { variant: "body2" },
                        React.createElement("a", { href: "mailto:member@usni.org" }, "member@usni.org"))),
                React.createElement(Grid_1.default, { item: true, xs: 4, className: classes.footerColumn },
                    React.createElement(Typography_1.default, { variant: "h5", className: classes.footerHeader }, "Media Inquiries"),
                    React.createElement(Typography_1.default, { variant: "body2" }, "(410) 295-1026"),
                    React.createElement(Typography_1.default, { variant: "body2" },
                        React.createElement("a", { href: "mailto:media@usni.org" }, "media@usni.org"))))));
    };
    return USNISiteFooter;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(USNISiteFooter);
